//
// locale_fr.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/fr.json';
import localeData from "react-intl/locale-data/fr.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
